import styled from "styled-components"
import media from "styled-media-query"

export const Container = styled.footer`
  width: 100%;
  padding: 2rem;

  ${media.greaterThan("medium")`
    height: 7rem;
    padding: 0 9rem;
    
    display: flex;
    align-items: center;
    justify-content: space-between;
  `}

  background: #FFF;
`

export const Copyright = styled.p`
  margin-bottom: 2rem;

  color: #888;
  font-size: 1rem;
  text-align: center;

  ${media.greaterThan("medium")`
    margin-bottom: 0rem;
  `}
`

export const Links = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Link = styled.a`
  color: #444;
  font-size: 0.9rem;
  font-weight: bold;

  &:not(:last-of-type) {
    margin-right: 2rem;
  }

  &:hover {
    cursor: pointer;
  }
`
